import { createBrowserHistory } from 'history';
import qs from 'qs';

export function parseUrl(url: string) {
  return qs.parse(url, { ignoreQueryPrefix: true });
}

const browserHistory = createBrowserHistory();
export default browserHistory;